import request from "../config/axios-config";

export function globalSearch(query, size, papersPage, contractsPage) {
  let url = "/search?q=" + encodeURIComponent(query.trim());
  if (size) {
    url += "&size=" + size;
  }
  if (papersPage) {
    url += "&papersPage=" + papersPage;
  }
  if (contractsPage) {
    url += "&contractsPage=" + contractsPage;
  }
  return request({
    method: "get",
    url: url,
  });
}
